'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function GA4Init() {
  useEffect(() => {
    const GA4_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;

    if (typeof window === 'undefined' || !GA4_MEASUREMENT_ID || window.gtag) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    const dataLayer: unknown[] = window.dataLayer || [];
    window.dataLayer = dataLayer;
    window.gtag = function gtag() {
      // biome-ignore lint: gtag.js requires the native Arguments object in dataLayer; rest params push a plain Array and events silently never transmit.
      dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID, {
      cookie_domain: 'auto',
      send_page_view: true,
    });
  }, []);

  return null;
}
